import React from 'react';
import { useTrekker } from 'utils/analytics';
import { useCurrencyContext } from '~/context/CurrencyContext';
import { useCurrenciesListContext } from '~/context/CurrencyListContext';

const CSS = require('./CurrencySwitch.module.scss');

interface CurrencySwitchProps {
  className?: string;
  trackingId?: string;
  onCurrencyChange?: (newCurrency: string) => void;
}

function CurrencySwitch({
  className,
  trackingId,
  onCurrencyChange,
}: CurrencySwitchProps) {
  const { state, actions } = useCurrencyContext();
  const { state: currenciesListState } = useCurrenciesListContext();
  const { currencies, loading } = currenciesListState;
  const trekker = useTrekker();

  const handleClick = () => {
    trekker.event('click', {
      component: ['CurrencySwitch'],
      target: trackingId,
      action: 'open currency switch',
    });
  };

  const handleCurrencyChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newCurrency = event.target.value;
    if (newCurrency !== state.currency) {
      actions.setCurrency(newCurrency);
      onCurrencyChange?.(newCurrency);
      trekker.event('click', {
        component: ['CurrencySwitch'],
        target: trackingId,
        action: `change ${state.currency} to ${newCurrency}`,
      });
    }
  };

  if (loading || currencies.length === 0) {
    return null;
  }

  return (
    <div className={`${CSS.CurrencySwitch} ${className || ''}`}>
      <span className={CSS.CurrencyLabel}>Prices in {state.currency}</span>
      <span className={CSS.Separator}>·</span>
      <span className={CSS.SelectWrapper}>
        <span className={CSS.ChangeLabel}>Change</span>
        <select
          className={CSS.CurrencySelect}
          value={state.currency}
          onClick={handleClick}
          onChange={handleCurrencyChange}
          aria-label="Change currency"
        >
          {currencies.map(({ code, symbol_native }) => (
            <option key={code} value={code}>
              {code} ({symbol_native})
            </option>
          ))}
        </select>
      </span>
    </div>
  );
}

export default CurrencySwitch;
